module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": true,
      "width": "1400px",
      "set-class": "no-padding-mobile"
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header default-image",
    style: ((_vm.unit && (_vm.unit.image || (_vm.unit.pool && _vm.unit.pool.image))) ? 'background-image:url(' + (_vm.unit && (_vm.unit.image || (_vm.unit.pool && _vm.unit.pool.image))) + ')' : 'background-size: cover;')
  }, [(_vm.unit) ? _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "heading-inner"
  }, [_vm._v("\n          " + _vm._s((_vm.unit.display_name || _vm.unit.description_title)) + "\n          "), (_vm.unit.subtitle) ? _c('i', [_vm._v(_vm._s(_vm.unit.subtitle))]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.accomodationView && _vm.$store.state.accomodationView === 'images') ? _c('div', {
    staticClass: "notification center"
  }, [_c('p', [_vm._v("Du visar nu våra boenden i ett specialläge där du kan ladda ner bilder.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goToNormal()
      }
    }
  }, [_vm._v("Gå till vanliga visningsläget")])])]) : _vm._e(), _vm._v(" "), (_vm.unit) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-right max-tablet "
  }, [(_vm.arrival) ? _c('AccomodationPeriodConfirm', {
    staticClass: "tighter",
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure
    },
    on: {
      "gotprice": _vm.setPeriod
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$route.params.arrival) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.openPriceList(_vm.unit)
      }
    }
  }, [_vm._v("Priser och tillgänglighet "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.arrival && _vm.period && _vm.period.free) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.chooseAccomodation({
          pool_lid: _vm.unit.pool_lid,
          unit_lid: _vm.unit.unit_lid,
          period: _vm.period,
          week: _vm.period.week,
          name: (_vm.unit.display_name || _vm.unit.description_title),
          capacity: _vm.unit.capacity,
          price: _vm.period.price
        })
      }
    }
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.arrival && !_vm.period) ? _c('button', {
    staticClass: "disabled"
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.period && !_vm.period.free) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.period && !_vm.period.free) ? _c('div', {
    staticClass: "alert"
  }, [_c('p', [_vm._v("Den valda perioden är tyvärr upptagen. Leta gärna andra perioder genom att klicka på \"Ändra datum\" ovan.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "max-tablet save-mobile"
  }, [(!_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart",
      "scale": 1.5
    }
  }), _vm._v(" Spara och jämför\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart-red",
      "scale": 1.5
    }
  }), _vm._v(" Sparad för jämförelse\n        ")], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    class: [
      'tab',
      _vm.activeTab === 'info' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('info')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "info-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "min-tablet"
  }, [_vm._v("Beskrivning")]), _vm._v(" "), _c('span', {
    staticClass: "max-mobile"
  }, [_vm._v("Info")])])], 1), _vm._v(" "), _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'images' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('images')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "img-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "img-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Bilder")])], 1), _vm._v(" "), (!(_vm.unit && _vm.unit.pool) || !_vm.unit.pool.hide_map) ? _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'map' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('map')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "map-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "map-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Karta")])], 1) : _vm._e(), _vm._v(" "), ((_vm.unit && _vm.unit.pool) && _vm.unit.pool.video) ? _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'video' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('video')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "play-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "play-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Film")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: [
      'fact',
      'tab',
      _vm.activeTab === 'fact' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('fact')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "facts-unit",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "facts-unit-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Fakta")])], 1)]), _vm._v(" "), (_vm.activeTab === 'info') ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.nl2br(_vm.unit.description_full))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'images') ? _c('div', {
    staticClass: "images"
  }, [_c('Slideshow', {
    attrs: {
      "images": _vm.unit.images
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'video') ? _c('div', {
    staticClass: "video"
  }, [_c('Vimeo', {
    attrs: {
      "url": _vm.unit.pool.video
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'fact') ? _c('div', {
    staticClass: "fact min-mobile"
  }, [(!_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "direktincheck",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.direct_incheck ? 1 : 0].title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.direct_incheck ? 1 : 0].description))])])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active && _vm.unit.lock_type_id) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "direktincheck",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].description))])])]) : _vm._e(), _vm._v(" "), (_vm.unit.dishwasher_usp) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "dishwasher-filled",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.unit.dishwasher_usp_title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.unit.dishwasher_usp_text))])])]) : _vm._e(), _vm._v(" "), _c('UnitFacts', {
    attrs: {
      "unit": _vm.unit
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-right facts-desktop"
  }, [(_vm.arrival) ? _c('AccomodationPeriodConfirm', {
    staticClass: "tighter",
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure
    },
    on: {
      "gotprice": _vm.setPeriod
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$route.params.arrival) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.openPriceList(_vm.unit)
      }
    }
  }, [_vm._v("Priser och tillgänglighet "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.arrival && _vm.period && _vm.period.free) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.chooseAccomodation({
          pool_lid: _vm.unit.pool_lid,
          unit_lid: _vm.unit.unit_lid,
          period: _vm.period,
          week: _vm.period.week,
          name: (_vm.unit.display_name || _vm.unit.description_title),
          capacity: _vm.unit.capacity,
          price: _vm.period.price
        })
      }
    }
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.arrival && !_vm.period) ? _c('button', {
    staticClass: "disabled"
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.period && !_vm.period.free) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.period && !_vm.period.free) ? _c('div', {
    staticClass: "alert"
  }, [_c('p', [_vm._v("Den valda perioden är tyvärr upptagen. Leta gärna andra perioder genom att klicka på \"Ändra datum\" ovan.")])]) : _vm._e(), _vm._v(" "), (!_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart",
      "scale": 1.5
    }
  }), _vm._v(" Spara och jämför\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart-red",
      "scale": 1.5
    }
  }), _vm._v(" Sparad för jämförelse\n      ")], 1) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "direktincheck",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.direct_incheck ? 1 : 0].title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.direct_incheck ? 1 : 0].description))])])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active && _vm.unit.lock_type_id) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "direktincheck",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].description))])])]) : _vm._e(), _vm._v(" "), (_vm.unit.dishwasher_usp) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "dishwasher-filled",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.unit.dishwasher_usp_title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.unit.dishwasher_usp_text))])])]) : _vm._e(), _vm._v(" "), _c('UnitFacts', {
    attrs: {
      "unit": _vm.unit
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.unit) ? _c('div', {
    staticClass: "max-tablet save-mobile"
  }, [(!_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart",
      "scale": 1.5
    }
  }), _vm._v(" Spara och jämför\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart-red",
      "scale": 1.5
    }
  }), _vm._v(" Sparad för jämförelse\n    ")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('pre', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5722638b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Accomodation/AccomodationsPageInfo.vue
// module id = 994
// module chunks = 0